export const ON_ANSWER = 'community/PROPOSITION_ANSWER_MOBILE_ON_ANSWER';
export const MODAL_OPEN = 'community/PROPOSITION_ANSWER_MOBILE_MODAL_OPEN';
export const MODAL_CLOSE = 'community/PROPOSITION_ANSWER_MOBILE_MODAL_CLOSE';

export const ON_CLICK = 'community/PROPOSITION_ANSWER_MOBILE_ON_CLICK';

export const POST_ANSWER_SUCCESS = 'community/PROPOSITION_ANSWER_MOBILE_POST_ANSWER_SUCCESS';
export const POST_ANSWER_FAILURE = 'community/PROPOSITION_ANSWER_MOBILE_POST_ANSWER_FAILURE';
